import { createContext, useContext, useState, useEffect } from 'react';
import memberApi from '../api/memberAxios';

const MemberAuthContext = createContext(null);

export const MemberAuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('member_token');
    const savedMember = localStorage.getItem('member_user');
    if (token && savedMember) {
      setMember(JSON.parse(savedMember));
      memberApi.get('/member-portal/profile')
        .then(res => {
          const memberData = res.data.member || res.data;
          setMember(memberData);
          localStorage.setItem('member_user', JSON.stringify(memberData));
        })
        .catch((err) => {
          // Sadece gercek yetki hatasinda cikis yap; 429/500/ag hatasinda oturumu KORU.
          if (err.response && (err.response.status === 401 || err.response.status === 403)) {
            localStorage.removeItem('member_token');
            localStorage.removeItem('member_user');
            setMember(null);
          }
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await memberApi.post('/member-portal/login', { email, password });
    localStorage.setItem('member_token', res.data.token);
    localStorage.setItem('member_user', JSON.stringify(res.data.member));
    setMember(res.data.member);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('member_token');
    localStorage.removeItem('member_user');
    setMember(null);
  };

  const updateMember = (data) => {
    setMember(data);
    localStorage.setItem('member_user', JSON.stringify(data));
  };

  return (
    <MemberAuthContext.Provider value={{ member, login, logout, loading, updateMember }}>
      {children}
    </MemberAuthContext.Provider>
  );
};

export const useMemberAuth = () => useContext(MemberAuthContext);
